<template>
  <el-container>
    <!-- 主体内容 -->
    <el-header style="display: flex; align-items: center; justify-content: space-between">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>负面舆情审杳</el-breadcrumb-item>
      </el-breadcrumb>
      <el-button-group>
        <el-button type="info" icon="el-icon-position" @click.native="formSubmit(1)"
          :disabled="data.lastNode.isSucces">提 交</el-button>
        <el-button type="info" icon="el-icon-eleme" @click.native="browser()">舆情来源</el-button>
        <el-button type="info" icon="el-icon-back" @click.native="formReturn()">返 回</el-button></el-button-group>
    </el-header>
    <el-main>
      <div>
        <el-tabs type="card" :tab-position="tabPosition" v-model="activeTabName">
          <el-tab-pane :key="0" name="tabFirst">
            <span slot="label"><i class="el-icon-date"></i> 工单信息</span>
            <el-form :model="data.pst" ref="pstRef" status-icon label-width="100px">
              <el-form-item label="上报人" prop="userName">
                <el-input v-model="data.pst.userName" disabled />
              </el-form-item>
              <el-form-item label="上报单位" prop="unitName">
                <el-input v-model="data.pst.unitName" disabled />
              </el-form-item>
              <el-form-item label="舆情类别" prop="pstType">
                <el-input v-model="data.pstTypeName" disabled />
              </el-form-item>
              <el-form-item label="发贴标题" prop="title">
                <el-input v-model="data.pst.title" disabled />
              </el-form-item>
              <el-form-item label="发贴人" prop="name">
                <el-input v-model="data.pst.name" disabled />
              </el-form-item>
              <el-form-item label="发贴时间" prop="postingTime">
                <el-input v-model="data.pst.postingTime" disabled />
              </el-form-item>
              <el-form-item label="来源" prop="pstSource">
                <el-input v-model="data.pst.pstSource" disabled />
              </el-form-item>
              <el-form-item label="贴子内容" prop="pstContent">
                <el-input type="textarea" :rows="10" v-model="data.pst.pstContent" disabled />
              </el-form-item>
              <el-form-item label="状态" prop="statusName">
                <el-input v-model="data.statusName" disabled />
              </el-form-item>
              <el-form-item label="佐证材料" v-if="
                data.pst.nodeInfos && data.pst.nodeInfos[0].uploadCount > 0
              ">
                <el-card class="box-card">
                  <upload :nodeId="data.pst.nodeInfos[0].id" :disabled="true" />
                </el-card>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane :key="node.id" v-for="node in data.nodes" :name="'tab' + node.id">
            <span slot="label"><i :class="pstApi.getStatusIcon(node.status)"></i>
              {{ pstApi.getNodeTitle(node.status) }}</span>
            <el-form :model="node" status-icon label-width="100px">
              <el-form-item label="办理单位">
                <el-input v-model="node.unitName" disabled />
              </el-form-item>
              <el-form-item label="办理人">
                <el-input v-model="node.userName" disabled />
              </el-form-item>
              <el-form-item label="答复留言" v-if="node.nodeContent.length > 0">
                <el-input type="textarea" :rows="2" v-model="node.nodeMessage" disabled />
              </el-form-item>
              <el-form-item label="提交信息" v-if="node.nodeMessage.length > 0">
                <el-input type="textarea" :rows="2" v-model="node.nodeMessage" disabled />
              </el-form-item>
              <el-form-item :label="pstApi.getTimeTitle(node.status)">
                <el-input :value="node.lastTime
                  ? Common.dateFormatter(node.lastTime, 'yyyy-MM-dd hh:mm')
                  : ''
                  " disabled />
              </el-form-item>
              <el-form-item label="佐证材料" v-if="node.uploadCount > 0">
                <el-card class="box-card">
                  <upload :nodeId="node.id" :disabled="true" />
                </el-card>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane :key="data.nodes.length + 1" name="tabLast">
            <span slot="label"><i class="el-icon-s-check"></i>
              <font color="green"> 舆情审查 </font>
            </span>
            <el-form :model="data.lastNode" status-icon label-width="100px">
              <el-form-item label="办理方式" prop="selectType">
                <el-radio-group v-model="data.form.selectType">
                  <el-radio :label="0">转为新舆情</el-radio>
                  <el-radio :label="-1">存档备查</el-radio>
                  <el-radio :label="-2">撤销重报</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="回复说明" v-if="data.lastNode.nodeContent">
                <el-input type="textarea" :rows="3" v-model="data.lastNode.nodeContent" disabled />
              </el-form-item>
              <el-form-item label="相关单位" v-if="data.form.selectType == -1">
                <el-select class="tel" v-model="data.form.transferUnitId" placeholder="请选择单位" clearable filterable>
                  <el-option v-for="unit in data.units" :key="unit.id" :label="unit.name" :value="unit.id" />
                </el-select>
              </el-form-item>
              <el-form-item label="办理说明">
                <el-input type="textarea" :rows="3" v-model="data.form.message" />
              </el-form-item>
              <el-form-item label="发贴标题" prop="title">
                <el-input v-model="data.pst.title" disabled />
              </el-form-item>
              <el-form-item label="贴子内容" prop="pstContent">
                <el-input type="textarea" :rows="5" v-model="data.pst.pstContent" disabled />
              </el-form-item>
              <el-form-item label="佐证材料" v-if="
                data.pst.nodeInfos && data.pst.nodeInfos[0].uploadCount > 0
              ">
                <el-card class="box-card">
                  <upload :nodeId="data.pst.nodeInfos[0].id" :disabled="true" />
                </el-card>
              </el-form-item>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import upload from "../../../components/Contents.vue";
export default {
  components: {
    upload,
  },
  created() {
    this.data.pst.id = this.$route.params.id;
    this.data.user = this.pstApi.getUserData();
    this.getUnits(); //读取所有单位信息
    this.getPst(); //读取舆情  信息
  },
  data() {
    return {
      tabPosition: "right",
      activeTabName: "tabLast",
      //数据项
      data: {
        user: "",
        statusName: "",
        pstTypeName: "",
        units: [], //单位数据
        pst: {
          id: "",
          unitName: "",
        },
        nodes: "",
        lastNode: {
          id: "",
          isSucces: false,
          lastTime: "",
          nodeContent: "",
          nodeMessage: "",
          pstId: "",
          pstType: 1,
          status: -1,
          transferUnitId: "",
          transferUnitName: "",
          unitId: "",
          unitName: "",
          userId: "",
          userName: "",
          uploadCount: 0,
        },
        form: {
          selectType: -1,
          message: "",
          transferUnitId: "",
        },
      },
    };
  },
  methods: {
    getUnits() {
      this.data.units = [];
      this.userApi.getUnitAll().then((res) => {
        var data = res.data;
        this.data.units = this.data.units.concat(data);
      });
    },
    //读取舆情信息
    getPst() {
      let pstId = this.data.pst.id;
      this.pstApi
        //.getNegativeSubmit(this.data.pst.id)
        .getPstInfo(pstId)
        .then((res) => {
          var data = res.data;
          this.data.pst = data;
          //console.log(data);
          this.data.nodes = data.nodeInfos.filter(
            (node) => node.isSucces == true
          );
          var transferNodes = data.nodeInfos.filter(
            (node) => node.isSucces == false
          );
          //console.log(transferNodes)
          if (transferNodes.length > 0) {
            this.data.lastNode = transferNodes[0];
          }
          this.data.form.selectType = this.data.lastNode.status;
          this.data.form.message = this.data.lastNode.nodeMessage;
          this.data.lastNode.unitId = this.data.user.unitId;
          this.data.lastNode.unitName = this.data.user.unitName;
          this.data.lastNode.userId = this.data.user.userId;
          this.data.lastNode.userName = this.data.user.name;

          this.data.statusName = this.pstApi.getStatusTransferTitle(
            this.data.pst.status
          );
          //console.log('title:',this.data.statusName)
          this.data.pstTypeName = this.pstApi.getPstTypeName(
            this.data.pst.pstType
          );
          //this.getUnits(); //读取所有单位信息
        })
        .catch((err) => {
          this.$toast("读取失败");
        });
    },
    //负面舆情审核
    formSubmit(buttonType) {
      let pstId = this.data.pst.id;
      let status = this.data.form.selectType;
      let message = this.data.form.message;
      var transferUnId = "00000000-0000-0000-0000-000000000000";
      if (status == -1 && this.data.form.transferUnitId != "") {
        transferUnId = this.data.form.transferUnitId;
      }
      // //0-保存 1-提交
      let submitType = buttonType;
      if (message == "" && submitType == 1) {
        if (status == 0) {
          message = "转为新舆情";
        } else if (status == -1) {
          message = "存档备查";
        } else if (status == -2) {
          message = "请重新上报";
        }
      }
      // if (status < -2 || status > 0 || message == "") {
      //   this.$toast("说明不能为空");
      //   return;
      // }
      this.pstApi
        .negativeAudit(pstId, message, submitType, status, transferUnId)
        .then(() => {
          if (status == -2) {
            this.$toast("撤销成功");
            this.formReturn();
          } else if (buttonType == 1) {
            if (status == -1) {
              this.$toast("收藏成功");
            } else {
              this.$toast("审核成功");
            }
            this.formReturn();
          } else {
            this.$toast("保存成功");
          }
        })
        .catch(() => {
          this.$toast("审核失败");
        });
    },
    formReturn() {
      this.$router.back();
    },
    browser() {
      window.open(this.data.pst.pstUrl, "_blank");
    },
  },
};
</script>

<style lang="less" scoped>
.el-header {
  background-color: #b3c0d1;
  color: #333;
  line-height: 40px;
}

//工具栏样式
.cust_seach {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  width: 100%;
  padding: auto 5px;

  .btnLeft {
    flex: 1;
    margin: 0;

    /deep/ .el-input__inner {
      height: 41px;
      border-radius: 0px;
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    }
  }

  .btnTitle {
    flex: 2;
    margin: 0;

    /deep/ .el-input__inner {
      height: 41px;
      border-radius: 0px;
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
    }
  }

  .btnStatus {
    flex: 1;
    margin: 0;

    /deep/ .el-input__inner {
      height: 41px;
      border-radius: 0px;
      border-top-right-radius: 0px;
      border-bottom-right-radius: 0px;
    }
  }

  .el-button-group>.el-button:first-child:last-child {
    border-radius: 0px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
}

.el-select {
  float: left;
}

.cust_pagin {
  display: flex;
  position: sticky;
  bottom: 0;
  z-index: 999;
}

/deep/.el-breadcrumb__separator {
  color: rgb(87, 86, 86);
}

/deep/.el-textarea.is-disabled .el-textarea__inner {
  background-color: #fff;
  border-color: #e4e7ed;
  color: #031944;
  cursor: auto;
}

/deep/.el-input.is-disabled .el-input__inner {
  background-color: #fff;
  border-color: #e4e7ed;
  color: #031944;
  cursor: auto;
}
</style>